"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadKybDocumentSchema = exports.KYB_EXPIRING_WARN_DAYS = exports.KYB_SLOT_STATES = void 0;
const zod_1 = require("zod");
const company_document_types_1 = require("../documents/company-document-types");
exports.KYB_SLOT_STATES = ['Present', 'Expiring', 'Expired', 'Missing', 'Exempted'];
exports.KYB_EXPIRING_WARN_DAYS = 60;
exports.uploadKybDocumentSchema = zod_1.z
    .object({
    file_id: zod_1.z.string().uuid(),
    document_type: company_document_types_1.companyDocumentTypeSchema,
    issue_date: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/u, 'issue_date must be ISO date YYYY-MM-DD'),
    expiry_date: zod_1.z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/u, 'expiry_date must be ISO date YYYY-MM-DD')
        .optional(),
})
    .strict();
//# sourceMappingURL=compliance-documents.js.map